import { ShowHeader } from '@/common/components/ShowHeader'
import { useParams } from 'react-router-dom'
import { PaymentAdvanceEstimateData } from '../../types/paymentAdvanceEstimate.type'
import { formatCurrency } from '@/common/utils/formatters';

interface PaymentAdvanceCreateNotAllowedProps {
  estimateData: PaymentAdvanceEstimateData;
}

const PaymentAdvanceCreateNotAllowed = ({ estimateData }: PaymentAdvanceCreateNotAllowedProps) => {
  const { billId } = useParams()

  return (
    <div>
      <ShowHeader
        goBack
        backTo={`/billing-bills/${billId}/payment-advances`}
        title="Antecipação não permitida"
      />

      <div className="h-[calc((100vh-256px))] flex flex-col items-center justify-center">
        <img src='/alert-blue.svg' />

        <div className='flex flex-col items-center gap-6'>
          <p className='text-lg font-bold'>
            Essa fatura não possui valor suficiente para antecipação
          </p>

          <p className='max-w-96 text-center'>
            Cada fatura pode ter uma ou mais antecipações. O valor restante disponível nesta fatura não atinge o mínimo necessário para antecipação.
          </p>

          {estimateData?.max_interested_available_to_be_advanced && (
            <p className='italic font-light'>
              Valor mínimo para adiantamento {formatCurrency(Number(estimateData?.max_interested_available_to_be_advanced))}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default PaymentAdvanceCreateNotAllowed
